/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import React from "react";

import { AdController, ClosePlayerButton } from "../../Interface";

import { usePlayerOverlayVisibility } from "./usePlayerOverlayVisibility";

import "./Container.scss";

export const AdBreakOverlay = () => {
  const { isVisible, onMouseMove } = usePlayerOverlayVisibility();

  return (
    <div className="OverlayContainer" onMouseMove={onMouseMove}>
      <div className="OverlayContainer__TopSection" data-visible={isVisible}>
        <ClosePlayerButton />
      </div>
      <div className="OverlayContainer__CenterSection" />
      <div className="OverlayContainer__BottomSection" data-visible={isVisible}>
        <AdController />
      </div>
    </div>
  );
};
